import defaultColor from "@/components/color";

export default {
    cptDataForm: {dataText: '{"value":66}', dataSource: 1, pollTime: 0},
    attribute: {
        borderWidth: 2, borderRadius: 4, borderGap: 3,
        lineWidth: 3, lineSpace: 2, localGradient: true,
        colors: [defaultColor[0], defaultColor[1]],numShow:true, textColor: '#fff',
        cptTableData: [{ "name": "指标", "value": "", "namekey": "value" }]
    },
}